import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Uris } from '../public/Uris';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GlobalFunction } from '../public/globalFunction';

@Injectable({
  providedIn: 'root',
})
export class HarvestsService {
  constructor(
    public http: HttpClient,
    public router: Router,
    public GlobalFunction: GlobalFunction
  ) {}

  createHarvest(data: any) {
    return this.http
      .post(`${Uris.API_HARVEST}`, data, this.GlobalFunction.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.GlobalFunction.validateError(err);
        })
      );
  }
}